import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MyoderService } from '../shared/myoder.service';
import { OrderDetail, OrderItem } from '../../models/orders.model';
import { Order } from '../../models/orders.model';
import { Sort } from '@angular/material/sort';
import { BrandListReturn } from '../../models/search-brand-result.model';
import { FileService } from '../../services/file.service';
import { CommonService } from '../../services';

@Component({
  selector: 'app-order-item-detail',
  templateUrl: './order-item-detail.component.html',
  styleUrls: ['./order-item-detail.component.css']
})

export class OrderItemDetailComponent implements OnInit {
  @ViewChild("ParentWrapper", { static: true }) parentWrapper: ElementRef;
  title = 'ORDER DETAIL';

  buttonText: string;

  orderSearch: string;

  filterInput = '';

  orderNumber = '';

  orderSuffix = '';

  routeLast: string;

  searchField: string;

  items: OrderItem[];

  sohArr: string[] = []; // use to check all items has a value of soh field

  orderDetail: OrderDetail;

  prevPage: string;

  order: Order;

  p = 1;

  pageloaded = false;

  loadContent = false;

  searchResult: BrandListReturn[] = [];

  stockList: string[] = [];

  urlPath: string;

  shippedOrderDetail: boolean;

  totalEx:string ='0.00';

  constructor(
    private router: Router,
    private orderService: MyoderService,
    private activeRouter: ActivatedRoute,
    private fileService: FileService,
    private commonService: CommonService
  ) { }

  ngOnInit() {

    if (this.router.url.startsWith('/myOrder/shippedorders/orderitemdetail') || this.router.url.startsWith('/myOrder/searchorders')) {
      this.shippedOrderDetail = true;
    } else {
      this.shippedOrderDetail = false;
    }

    this.activeRouter.parent.url.subscribe(url => {
      this.urlPath = url[0].path;
    },
      (error: any) => {
        this.loadContent = true;
        console.error(error);
      });

    /*subscript to watch the route para changes.
    **************Please make changes inside this subscription. Don't delete it ***************/
    // Subscription One: link to the URL param to watch the change of order number
    this.activeRouter.paramMap.subscribe(param => {
      this.sohArr = [];
      this.searchResult = [];
      this.pageloaded = false;
      this.loadContent = false;
      this.orderSearch = param.get('sku');
      // split the param to order number & order suffix
      const orderSeachArray = this.orderSearch.match(/[a-z]+|[^a-z]+/gi);
      this.orderNumber = orderSeachArray[0];
      this.orderSuffix = '';
      if (orderSeachArray[1]) { this.orderSuffix = orderSeachArray[1]; }
      $('#levelOne').animate(
        { scrollLeft: (252) },
        {
          duration: 400,
          complete: function () {
            $('.combination-loader').stop(true, false);
          }
        });

      this.getOrderDetails();

      if (this.router.url.includes('myAccount/openorders/orderitemdetail')) {
        $('#levelOne').animate({ scrollLeft: $('.renewal-list-mini').width() }, 400);
      }
      // Subscription Two: get the order object
      // this.orderService.getSearchOrders(this.orderNumber, this.p).subscribe(
      //   (value: Order[]) => {
      //     this.order = value[0];
      //     // Subscription Three: get the order details
      //     this.orderService.GetOrderDetails(this.orderNumber, this.order.orderSuffix).subscribe(
      //       (data: OrderDetail) => {
      //         this.orderDetail = data;
      //         this.items = data.items;
      //         this.pageloaded = true;
      //       },
      //       (error: any) => {
      //         console.info(error);
      //         this.loadContent = true;
      //       },
      //       () => {
      //         // TODO: Subscription Three: use new API "GetProductPricing" to get the product details.
      //         // this.stockList = (this.items.map(x=>x.stockCode));
      //         // console.log(this.stockList);

      //         // this.productService.GetProductPricing(this.stockList).subscribe(
      //         //   (res) => {
      //         //     console.log(res);
      //         //   },
      //         //   (error: any) =>{ console.log(error);},
      //         //   () => {
      //         //   }
      //         // );
      //         // --------------------------------------------------------------------------
      //         // if (this.items.length > 0) {
      //         //   this.items.forEach(element => {
      //         //     //Subscription Four: get SOH value for each item
      //         //     this.productService.GetFullStockProductDetails(element.stockCode).subscribe(
      //         //       (res) => {
      //         //         let sohType: any;
      //         //         if (res.mainProduct.freightPolicy) {
      //         //           if (res.mainProduct.freightPolicy.toString() == "E") {
      //         //             sohType = "ELECTRONIC";
      //         //           } else if (res.mainProduct.freightPolicy.toString() == "L") {
      //         //             sohType = "LABOUR";
      //         //           }
      //         //         }

      //         //         if (res.mainProduct.stockCode) {
      //         //           this.sohArr.push(getStockOnHand(res.mainProduct.availQty, res.mainProduct.maxAvailQty, res.mainProduct.eta, res.mainProduct.freightPolicy, sohType));
      //         //           element.soh = getStockOnHand(res.mainProduct.availQty, res.mainProduct.maxAvailQty, res.mainProduct.eta, res.mainProduct.freightPolicy, sohType);
      //         //           element.brand = res.mainProduct.stkBrand;
      //         //           element.status = res.mainProduct.stockStatus;
      //         //           element.sku = res.mainProduct.stockCode;
      //         //           element.promotion = res.mainProduct.promoFinish;
      //         //           element.availableQty = res.mainProduct.availQty;
      //         //           element.bundledProductList = res.bundledProductList;
      //         //         } else {
      //         //           this.sohArr.push("null");
      //         //           element.soh = "null";
      //         //           element.brand = "null";
      //         //           element.brand = "null";
      //         //           element.status = "null";
      //         //           element.sku = "null";
      //         //           element.promotion = "null";
      //         //           element.availableQty = "null";
      //         //         }
      //         //         this.loadContent = true;
      //         //       },
      //         //       (error: any) => {
      //         //         console.log(error);
      //         //         this.loadContent = true;
      //         //       });
      //         //   });
      //         // } else {
      //         //   this.pageloaded = true;
      //         //   this.loadContent = true;
      //         // }
      //         // -------------------------------------------------------------------------
      //       });
      //   },
      //   (error: any) => {
      //     this.loadContent = true;
      //     console.info(error);
      //   });
    });
  }

  getOrderDetails() {
    this.orderService.GetOrderDetails(this.orderNumber, this.orderSuffix).subscribe(
      (data: OrderDetail) => {
        this.orderDetail = data;
        this.items = data.items.map(item => {
          const qtyAllocated = parseInt(item.qtyAllocated) || 0; 
          const unitCostEx = parseFloat(item.unitCostEx) || 0; 
      
  
          const subtotalNew = (qtyAllocated * unitCostEx).toFixed(2);
      
          return {
              ...item,
              subtotalNew: subtotalNew === "0.00" ? "0.00" : subtotalNew 
            };
          });
          this.totalEx = this.items.reduce((total, item) => {
            return total + parseFloat(item.subtotalNew); 
        }, 0).toFixed(2); 
        this.pageloaded = true;
        this.loadContent = true;
        this.orderService.openOrders$.asObservable().subscribe((value: Order[]) => {
          if (value && value.length) {
            this.order = value.filter(x => x.orderNo === this.orderDetail.orderNo)[0];
            if (this.order) {
              this.order.showPayNowBtn = false;
              if (!this.order.isCreditAccount && this.commonService.toNumber(this.order.totalEx) > this.commonService.toNumber(this.order.prePaidAmount) && this.commonService.toNumber(this.order.totalEx) > 0) {
                this.order.showPayNowBtn = true;
              }
            }
          }
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
        this.commonService.applyScrollFixedHeader(this.parentWrapper);
      },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
     
  }

  checkDocumentAvailability() {
    if (this.orderDetail && (this.orderDetail.orderConfirmationUrl || this.orderDetail.creditNoteUrl || this.orderDetail.deliveryDocketUrl || this.orderDetail.invoiceUrl || this.orderDetail.quoteUrl || this.orderDetail.rmaUrl || this.orderDetail.resellerPOUrl || this.orderDetail.podUrl || this.orderDetail.orderAmendUrl || this.orderDetail.licenceAgreeUrl || this.orderDetail.configFileUrl || this.orderDetail.orderCancelUrl || this.orderDetail.supportConUrl || this.orderDetail.autopilotUrl)) {
      return true;
    } else {
      return false;
    }
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  // Original code used to define the value of prevPage. If the previous page is only from open page, this is not required.
  // --------------------------------------------------------------------------------
  // this.activeRouter.parent.url.subscribe(value => {
  //   this.prevPage = value[0].path;
  //   this.buttonText = this.prevPage.split("orders")[0].toUpperCase() + " ORDERS"
  // },
  //   (error: any) => {
  //     console.info(error);
  //     this.loadContent = true;
  //   });
  // --------------------------------------------------------------------------------

  sortData(sort: Sort) {
    const data = this.items.slice();
    if (!sort.active || sort.direction === '') {
      this.items = data;
      return;
    }

    this.items = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'description': return compare(a.lineDescription, b.lineDescription, isAsc);
        // tslint:disable-next-line:radix
        case 'soh': return compare(parseInt(a.soh), parseInt(b.soh), isAsc);
        case 'price': return compare(parseFloat(a.unitCostEx), parseFloat(b.unitCostEx), isAsc);
        // tslint:disable-next-line:radix
        case 'orderStatus': return compare(parseInt(a.qtyOrdered), parseInt(b.qtyOrdered), isAsc);
        case 'holdReason': return compare(parseFloat(a.subtotalEx), parseFloat(b.subtotalEx), isAsc);
        default: return 0;
      }
    });
  }

  payOrder(): void {
    this.router.navigate(['payment'], {
      relativeTo: this.activeRouter,
      queryParams: {
        orderNumber: this.orderNumber,
        paymentFor: 'order',
        orderSuffix: this.orderSuffix
      },
      skipLocationChange: true
    });
  }

  exportOrderSerials(orderNumber: string, orderSuffix: string) {
    this.orderService.exportExportOrderSerials(orderNumber, orderSuffix)
      .subscribe(data => {
        const fileName = `DD_OrderSerials_${orderNumber}.xlsx`;
        this.fileService.saveAsExcelFile(data, fileName);
      },
        (error: any) => {
          console.error(error);
        });
  }

  checkProductDetail(stockCode: string): void {
    stockCode = encodeURIComponent(stockCode);
    this.router.navigate([`product/${stockCode}`], { relativeTo: this.activeRouter });
  }

  close() {
    if (this.router.url.includes('myAccount/openorders/orderitemdetail')) {
      $('#levelOne').animate({ scrollLeft: 0 }, 400);
    } else {
      $('.page-contents').animate({ scrollLeft: $('#levelOne').width() }, 400);
    }
    this.router.navigate(['.'], { relativeTo: this.activeRouter.parent });
  }

  convertQty(qty: string): string {

    if (qty.includes('-')) {
      return `-${qty.replace('-', '')}`;
    } else {
      return qty;
    }

  }

  convertTotal(total: string): number {
    return parseFloat(total.includes('-') ? total.replace('-', '') : total);
  }
}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

